'use strict';

require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.date.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
module.exports = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};